const flattenNestedCategories = categories => {
    let aligned = [];
    let sub = [];

    categories.forEach(item => {
        item = normalizeCompetency(item);

        if (hasChildren(item)) {
            sub = flattenNestedCategories(item.children);
            aligned = [...aligned, ...[item], ...sub];
            item.children = flattenChildIds(item);
        } else {
            // to keep the right order it's better to use
            // Array.push after the if statement implicitly
            aligned.push(item);
        }
    });

    return aligned;
};

const normalizeCompetency = item => {
    const { id, name, parent_id, children } = item;

    return {
        id,
        name,
        parentId: parent_id,
        children
    };
};


const hasChildren = item => item.children.length > 0;

const flattenChildIds = item => item.children.map(child => child.id);

export default flattenNestedCategories;


// WEBPACK FOOTER //
// ./web/src/selectors/flattenNestedCategoriesSelector.js